<!-- <template>
	<div class="emun_container full flex">
		<el-row style="position: relative;box-sizing: border-box;flex: 1;">
			<el-col class="" :span="4" style="overflow: auto;position: relative;height: 100%">
				<emun-tree ref="emuntTree" :key="emuntTreeKey" @select="emuntTreeChange" />
			</el-col>
			<el-col class="" :span="20"
				style="flex:1;border-left: 1px solid #DCDFE6;position: relative;padding: 20px;box-sizing: border-box;height: 100%">
				<vxe-grid :ref="moduleName+'_list'" v-bind="gridOptions" :key="gridKey" v-if="gridOptions && emunid"
					@toolbar-button-click="toolbarButtonClickEvent">
				</vxe-grid>
			</el-col>
		</el-row>

		<component :is="formModule.component" v-if="formModule.show" :name="formModule.name" :id="formModule.id"
			:controlltype="formModule.controlltype" :extra="formModule.extra" :foreingKey="formModule.foreingKey"
			@back="formBack" />
	</div>
</template>
<style scoped>
	.emun_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}
</style> -->
<script>
	import listBase from '@_system/components/base/list.vue'
	import emunTree from '@_system/components/formcomponents/common/select/emun/tree.vue'
	export default {
		extends: listBase,
		name: 'emunIndex',
		props: {

		},
		render(h) {
			this.$slots.mainheader = [
				<el-row>
					<el-button size="mini" type="primary" onClick={this.addlist}>添加</el-button>
					<el-button size="mini" type="success" onClick={this.editlist}>修改</el-button>
					<el-button size="mini" type="warning" onClick={this.extend}>扩展</el-button>
					<el-button size="mini" type="danger" onClick={this.dellist}>删除</el-button>
				</el-row>
			]
			this.$slots.aside = [<emun-tree ref="emuntTree" key={this.emuntTreeKey} onSelect={this.emuntTreeChange} />]

			
			return listBase.render.call(this, h)
		},
		data() {
			return {
				componenttype:'system',
				moduleName: 'emun',
				windowName: '枚举管理',
				emunid: 0,
				emunname: '',
				field: '',
				emuntTreeKey: Math.random(),
				listformData: {
					name: 'emunlist',
					id: 0,
					controlltype: 1,
					show: false
				},
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			beforeCreateGrid(formConfig, columns, gridOptions) {
				gridOptions.height = 700
				gridOptions.pagerConfig.enabled = false
			},
			emuntTreeChange(e) {
				this.emunid = e.id
				this.emunname = e.name
				this.field = e.field
				this.customreload()
			},
			beforeRequest(form, page) {
				form.onwerid = this.emunid
				page.currentPage = -1
			},
			addlist() {
				import('@_system/components/forms/emunlist/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'emunlist',
						id: 0,
						controlltype: 1,
						show: true
					}
				})
			},
			editlist() {
				if (this.emunid != 0) {
					import('@_system/components/forms/emunlist/form.vue').then((res) => {
						this.formModule = {
							component: res.default,
							name: 'emunlist',
							id: this.emunid,
							controlltype: 2,
							show: true
						}
					})
				} else {
					this.$message.error({
						message: '请选择枚举',
					})
				}

			},
			extend(){
				if (this.emunid != 0) {
					this.$api.emunlist.extend(this.field).then(()=>{
						import('@/views/main/emunextend/index.vue').then((res) => {
							this.formModule = {
								component: res.default,
								extra: {
									name: this.field,
									title: this.emunname,
								}
							}
						})
					})
				} else {
					this.$message.error({
						message: '请选择枚举',
					})
				}
			},
			add(e) {
				let data = this.$refs[this.moduleName + '_list'].getData()
				import('@_system/components/forms/emun/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'emun',
						id: 0,
						controlltype: 1,
						show: true,
						foreingKey: {
							parentid: e ? e.id : null,
							onwerid: this.emunid
						},
						extra: {
							lastvalue: data.length == 0 ? 1 : data[data.length - 1]['value'] + 1,
							title: e ? '枚举【父级:' + e.label + '】' : null,
							field: this.field
						}
					}
				})
			},
			edit(row) {
				import('@_system/components/forms/emun/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'emun',
						id: row.id,
						controlltype: 2,
						show: true,
						foreingKey: {
							parentid: row ? row.parentid : null,
							onwerid: this.emunid
						},
						extra: {
							field: this.field
						}
					}
				})


			},
			del(row) {
				this.$confirm('是否删除 ' + row.label, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.emun.delete(row.id, {
						onwerid: this.emunid
					}).then(() => {
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.customreload()
					})
				}).catch(() => {

				})


			},
			dellist() {
				if (this.emunid != 0) {
					this.$confirm('是否删除 ' + this.emunname, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$api.emunlist.delete(this.emunid).then(() => {
							this.$message({
								message: '操作成功',
								type: 'success'
							})
							this.emuntTreeKey = Math.random()
						})
					}).catch(() => {

					})
				} else {
					this.$message.error({
						message: '请选择枚举',
					})
				}

			},
			auth(row) {
				import('@_system/components/forms/auth/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'auth',
						id: row.id,
						show: true,
						extra: {
							type: 'emun',
						}
					}
				})
			},	
			formBack(e) {
				let component = this.formModule.component
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				}
				if (e.type != 'cancle') {
					if (component.name == 'emunForm') {
						this.customreload()
					} else {
						this.reloadlist()
					}
				}

			},
			reloadlist() {
				this.emuntTreeKey = Math.random()
			}
		},
		components: {
			emunTree,


		}
	}
</script>
